import { IMenuLink } from 'molecules/Header/Header/HeaderLinks';
import React, { createContext, useContext, PropsWithChildren } from 'react';
import { BreakpointKey } from 'styles/breakpoints';

interface HeaderCustomizationContextType {
  callToAction?: {
    link?: string;
    text?: string;
  };
  links?: IMenuLink[];
  mobileBreakpoint?: BreakpointKey | 'none';
  hideSideBar?: boolean;
  hideCallToAction?: boolean;
  hideSecondaryCallToAction?: boolean;
}

const HeaderCustomizationContext = createContext<HeaderCustomizationContextType | undefined>(undefined);

type HeaderCustomizationProviderProps = HeaderCustomizationContextType & PropsWithChildren;

export const HeaderCustomizationProvider = ({
  children,
  callToAction,
  links,
  mobileBreakpoint,
  hideSideBar,
  hideCallToAction,
  hideSecondaryCallToAction,
}: HeaderCustomizationProviderProps): JSX.Element => {
  return (
    <HeaderCustomizationContext.Provider
      value={{ callToAction, links, mobileBreakpoint, hideSideBar, hideCallToAction, hideSecondaryCallToAction }}
    >
      {children}
    </HeaderCustomizationContext.Provider>
  );
};

export const useHeaderCustomization = (): HeaderCustomizationContextType => {
  return useContext(HeaderCustomizationContext) ?? {};
};
